import React from "react";
//import { AUTH_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `/login`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
  },
  {
    key: "signup",
    path: `/signup`,
    component: React.lazy(
      () => import("views/auth-views/authentication/signup/index"),
    ),
  },

  {
    key: "reset-password",
    path: `/reset-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login/reset-password"),
    ),
  },
  {
    key: "forgot-password",
    path: `/forgot-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login/forgot-password"),
    ),
  },
];

export const backOfficeRoutes = [
  {
    key: "home",
    path: `/home`,
    component: React.lazy(() => import("views/app-views/admin-dashboard/home")),
    roles: ["backOffice"],
  },
  {
    key: "wallet",
    path: `/wallet`,
    component: React.lazy(
      () => import("views/app-views/admin-dashboard/wallet"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "payments",
    path: `/payments`,
    component: React.lazy(
      () => import("views/app-views/admin-dashboard/payments"),
    ),
    permissions: ["Payment.View"],
    roles: ["backOffice"],
  },
  {
    key: "payment-details",
    path: `/payments/:id`,
    permissions: ["Payment.View"],
    component: React.lazy(
      () => import("views/app-views/admin-dashboard/payments/PaymentDetails"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "statement",
    path: `/transactions`,
    component: React.lazy(
      () => import("views/app-views/admin-dashboard/transactions"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "transaction-details",
    path: `/transactions/:id`,
    component: React.lazy(
      () =>
        import("views/app-views/admin-dashboard/transactions/TransactionDetails"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "team",
    path: `/team`,
    component: React.lazy(() => import("views/app-views/admin-dashboard/team")),
    roles: ["backOffice"],
  },
  {
    key: "profile",
    path: `/profile`,
    component: React.lazy(
      () => import("views/app-views/admin-dashboard/company-profile"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "sender",
    path: `/sender`,
    permissions: ["Sender.View"],
    component: React.lazy(
      () => import("views/app-views/admin-dashboard/sender"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "sender-details",
    path: `/sender/:id`,
    component: React.lazy(
      () => import("views/app-views/admin-dashboard/sender/SenderDetails"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "beneficiaries",
    path: `/beneficiaries`,
    permissions: ["Beneficiary.View"],
    component: React.lazy(
      () => import("views/app-views/admin-dashboard/beneficiaries"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "beneficiary-details",
    path: `/beneficiaries/:id`,
    permissions: ["Beneficiary.View"],
    component: React.lazy(
      () =>
        import("views/app-views/admin-dashboard/beneficiaries/BeneficiaryDetails"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "account-settings",
    path: `/account-settings`,
    component: React.lazy(
      () => import("views/app-views/admin-dashboard/settings"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "faq",
    path: `/faq`,
    component: React.lazy(() => import("views/app-views/admin-dashboard/faq")),
    roles: ["backOffice"],
  },
  {
    key: "customer-management",
    path: `/customer-management`,
    component: React.lazy(
      () => import("views/app-views/admin-dashboard/customer-management"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "customer-management-details",
    path: `/customer-management/:id`,
    component: React.lazy(
      () =>
        import("views/app-views/admin-dashboard/customer-management/CustomerDetails"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "compliance-aml",
    path: `/compliance-aml`,
    component: React.lazy(
      () => import("views/app-views/admin-dashboard/coming-soon"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "reconciliation",
    path: `/reconciliation`,
    component: React.lazy(
      () => import("views/app-views/admin-dashboard/coming-soon"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "rates-fee",
    path: `/rates-fee`,
    component: React.lazy(
      () => import("views/app-views/admin-dashboard/coming-soon"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "admins-roles",
    path: `/admins-roles`,
    component: React.lazy(
      () => import("views/app-views/admin-dashboard/admins-roles"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "audit-log",
    path: `/audit-log`,
    component: React.lazy(
      () => import("views/app-views/admin-dashboard/coming-soon"),
    ),
    roles: ["backOffice"],
  },
  {
    key: "support",
    path: `/support`,
    component: React.lazy(
      () => import("views/app-views/admin-dashboard/support"),
    ),
    roles: ["backOffice"],
  },
];

export const customerRoutes = [
  {
    key: "home",
    path: `/home`,
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/home"),
    ),
    roles: ["sender"],
  },
  {
    key: "wallet",
    path: `/wallet`,
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/wallet"),
    ),
    roles: ["sender"],
  },
  {
    key: "bills-payment",
    path: `/bills-payment`,
    // permissions: ["Beneficiary.View"],
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/bills-payment"),
    ),
    roles: ["sender"],
  },
  {
    key: "bills-payment-form",
    path: `/bills-payment/:category`,
    component: React.lazy(
      () =>
        import("views/app-views/customer-dashboard/bills-payment/BillPaymentForm"),
    ),
    roles: ["sender"],
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "local-transfer",
    path: `/wallet/local-transfer`,
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/wallet/local-transfer"),
    ),
    roles: ["sender"],
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "self-transfer",
    path: `/wallet/self-transfer`,
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/wallet/self-transfer"),
    ),
    roles: ["sender"],
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "wallet-onboarding",
    path: `/wallet/wallet-onboarding`,
    component: React.lazy(
      () =>
        import("views/app-views/customer-dashboard/wallet/wallet-onboarding"),
    ),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "parkpay-transfer",
    path: `/wallet/parkpay-transfer`,
    component: React.lazy(
      () =>
        import("views/app-views/customer-dashboard/wallet/parkpay-transfer"),
    ),
    roles: ["sender"],
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "international-transfer",
    path: `/wallet/international-transfer`,
    component: React.lazy(
      () =>
        import("views/app-views/customer-dashboard/wallet/international-transfer"),
    ),
    roles: ["sender"],
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "swap",
    path: `/wallet/swap`,
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/wallet/swap"),
    ),
    roles: ["sender"],
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "transactions",
    path: `/transactions`,
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/transactions"),
    ),
    roles: ["sender"],
  },
  {
    key: "statements-reports",
    path: `/statements-reports`,
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/statement"),
    ),
    roles: ["sender"],
  },
  {
    key: "referrals",
    path: `/referrals`,
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/referral"),
    ),
    roles: ["sender"],
  },
  {
    key: "reward",
    path: `/reward`,
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/reward"),
    ),
    roles: ["sender"],
  },
  {
    key: "team",
    path: `/team`,
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/team"),
    ),
    roles: ["sender"],
    meta: {
      allowedIf: (userProfile) => userProfile?.isIndividual === false,
    },
  },
  {
    key: "approvals",
    path: `/transaction-approval`,
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/approvals"),
    ),
    roles: ["sender"],
    meta: {
      allowedIf: (userProfile) => userProfile?.orgMemberRole !== "Initiator",
    },
  },
  {
    key: "sender",
    path: `/sender`,
    // permissions: ["Sender.View"],
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/sender"),
    ),
    roles: ["sender"],
    meta: {
      allowedIf: (userProfile) => userProfile?.isIndividual === false,
    },
  },
  {
    key: "sender-add",
    path: `/sender/add`,
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/sender/AddSender"),
    ),
    roles: ["sender"],
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "beneficiaries",
    path: `/beneficiaries`,
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/beneficiary"),
    ),
    roles: ["sender"],
  },
  {
    key: "beneficiaries-add",
    path: `/beneficiaries/add`,
    component: React.lazy(
      () =>
        import("views/app-views/customer-dashboard/beneficiary/AddBeneficiary"),
    ),
    roles: ["sender"],
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "beneficiaries-edit",
    path: `/beneficiaries/edit`,
    component: React.lazy(
      () =>
        import("views/app-views/customer-dashboard/beneficiary/AddBeneficiary"),
    ),
    roles: ["sender"],
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "account-settings",
    path: `/account-settings`,
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/settings"),
    ),
    roles: ["sender"],
  },
  {
    key: "faq",
    path: `/faq`,
    component: React.lazy(
      () => import("views/app-views/customer-dashboard/faq"),
    ),
    roles: ["sender"],
  },
  {
    key: "personal-account-onboarding",
    path: `/personal-account-onboarding`,
    component: React.lazy(
      () => import("views/app-views/personal-account-onboarding"),
    ),
    meta: {
      blankLayout: true,
      bypassOnboarding: true,
    },
  },
  {
    key: "business-account-onboarding",
    path: `/business-account-onboarding`,
    component: React.lazy(
      () => import("views/app-views/business-account-onboarding"),
    ),
    meta: {
      blankLayout: true,
      bypassOnboarding: true,
    },
  },
];

export const commonRoutes = [
  {
    key: "error-page",
    path: `/error-page`,
    component: React.lazy(() => import("views/app-views/error")),
  },
];

export const sharedPublicRoutes = [
  {
    key: "terms-conditions",
    path: `/terms-conditions`,
    component: React.lazy(() => import("views/public-views/terms-conditions")),
    meta: {
      blankLayout: true,
      bypassOnboarding: true,
    },
  },
  {
    key: "privacy-policy",
    path: `/privacy-policy`,
    component: React.lazy(() => import("views/public-views/privacy-policy")),
    meta: {
      blankLayout: true,
      bypassOnboarding: true,
    },
  },
];
